// Single source of truth for the public app-store links.
// Both platforms are live: iOS on the App Store, Android on Google Play.
export const APP_STORE_URL = 'https://apps.apple.com/ua/app/gather-enjoy-real-events/id6760650128';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.community.gather';

// Event ids are `@PrimaryGeneratedColumn('uuid')` on the backend. Mirrors the
// regex the app uses in `parseEventIdFromReferrer` — anything the app would
// reject is not worth putting on the link.
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isEventId = (value: string | null | undefined): value is string =>
  !!value && UUID_REGEX.test(value);

/**
 * Google Play link that carries an event id through the install gap
 * (deferred deep linking, Android only).
 *
 * Play forwards `referrer` verbatim to the Install Referrer API, decoding it
 * once, so `referrer=eventId%3D<uuid>` reaches the app as `eventId=<uuid>` —
 * exactly what `parseEventIdFromReferrer` in gather-mobile expects. On first
 * launch the app reads it and opens the shared event.
 *
 * Falls back to the plain store link when there is no valid event id, so a
 * malformed `?event=` never produces a broken referrer.
 */
export const googlePlayUrl = (eventId?: string | null): string =>
  isEventId(eventId)
    ? `${GOOGLE_PLAY_URL}&referrer=${encodeURIComponent(`eventId=${eventId}`)}`
    : GOOGLE_PLAY_URL;
